import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Form, Row, Col, Button, FormLabel, Modal, Container, TextBox, InputGroup } from 'react-bootstrap';
import Picklist from './Picklist'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, dateFilter, Comparator } from 'react-bootstrap-table2-filter';
import { Layout } from "../Layout";
import paginationFactory, { PaginationProvider, SizePerPageDropdownStandalone, PaginationListStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator';

import PatientSearchService from '../../services/patientSearchService';
import ItnAuthService from '../../services/itnAuthService';
import AuthService from '../../services/authService';
import AnalyticsService from '../../services/analyticsService';
import { TruckFlatbed } from 'react-bootstrap-icons';
import ErrorDisplay from '../../services/errorDisplay';

import { ErrorBoundary } from 'react-error-boundary';



const ItnAuthList = (props) => {
    const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [cancelToken, setCancelToken] = useState();

    const [incidentData, setIncidentData] = useState([]);
    const [incidentTableData, setIncidentTableData] = useState([]);
    
    const [sortField, setSortField] = useState('itnNumber');
    const [sortDir, setSortDir] = useState('asc');

    const [incidentSortField, setIncidentSortField] = useState('incidentNumber');
    const [incidentSortDir, setIncidentSortDir] = useState('asc');

    const [numPerPage, setNumPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [showList, setShowList] = useState(false);
    const [allClients, setAllClients] = useState(true);
    const [clientList, setClientList] = useState();
    
    const [clientCodeList, setClientCodeList] = useState([]);
    const [selectedClientList, setSelectedClientList] = useState([]);

    const [showClientDropdown, setShowClientDropdown] = useState(false);
    const [showClientPicker, setShowClientPicker] = useState(false);
    const [clientsForDropdown, setClientsForDropdown] = useState([]);

    const [searchMsg, setSearchMsg] = useState('');
    const [noResultsMsg, setNoResultsMsg] = useState('No results');
    const [showNoRusults, setShowNoResults] = useState(false);
    
    const [showClientError, setShowClientError] = useState(false);
    const [clientError, setClientError] = useState("");

    const [rowToEdit, setRowToEdit] = useState();
    const [showModal, setShowModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const [incidentRowToEdit, setIncidentRowToEdit] = useState();
    const [showIncidentsModal, setShowIncidentsModal] = useState(false);
    const [incidentUtilization, setIncidentUtilization] = useState({});
    const [incidentBills, setIncidentBills] = useState([]);
    const [incidentBillsTableData, setIncidentBillsTableData] = useState([]);
    const [incidentBillsSortField, setIncidentBillsSortField] = useState('itnNumber');
    const [incidentBillsSortDir, setIncidentBillsSortDir] = useState('asc');
    const [spinnerEnabled, setSpinnerEnabled] = useState(false); // Toggle to enable/disable loading spinner
    const [isIncidentDataLoading, setIsIncidentDataLoading] = useState(false);

    const [denyList, setDenyList] = useState([]);
    const [infoList, setInfoList] = useState([]);
    const [selectedAction, setSelectedAction] = useState('N');


    const [patientResponsibilityValue, setPatientResponsibilityValue] = useState(0);
    const [maximumCoveredValue, setMaximumCoveredValue] = useState(0);
    const [denialCodeValue, setDenialCodeValue] = useState('');
    const [additionalInfoValue, setAdditionalInfoValue] = useState('');
    const [otherSpecialHandlingValue, setOtherSpecialHandlingValue] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

    const [approveByIncident, setApproveByIncident] = useState(true);
    const [approveByClaim, setApproveByClaim] = useState(false);

    useEffect(() => {
        PatientSearchService.getAvailableClients((data) => {
            setClientList(data);
            setClientCodeList(Object.keys(data));

            var keys = Object.keys(data);
            var dropdownClients = [];
            
            for (var i = 0; i < keys.length; i++) {
                var item = {};
                item.key = keys[i];
                item.value = data[item.key];
                dropdownClients.push(item);
            }

            setClientsForDropdown(dropdownClients);

            if (keys.length === 1) {
                setShowClientDropdown(true);
                setShowClientPicker(false);
                setAllClients(true);
            } else {
                setShowClientDropdown(false);
                setShowClientPicker(true);
            }
        });
        
        ItnAuthService.getDenyList(function (data) {
            setDenyList(data);
        });

        ItnAuthService.getInfoList(function (data) {
            setInfoList(data);
        });

    }, []);

    useEffect(() => {
        resetModal(true);

        if (rowToEdit?.itnNumber) {
            setPdfUrl('');
            AuthService.getAuthToken(false, (token) => {
                setPdfUrl("/api/itn/pdf/" + rowToEdit?.itnNumber + "?token=" + token);
            });
        }
    }, [rowToEdit]);

    useEffect(() => {
        setShowList(false);
    }, [approveByIncident, approveByClaim]);

    useEffect(() => {
        resetModal(false);

        if (selectedAction === "D") {
            setDenialCodeValue("0188");
        }

        if (selectedAction === "I") {
            setAdditionalInfoValue("0507");
        }

        if (selectedAction === "N") {
            setSaveButtonDisabled(true);
        } else {
            setSaveButtonDisabled(false);
        }

    }, [selectedAction]);

    const onSelectedClientsChange = (clients) => {
        setSelectedClientList(clients);
    }

    const claimsColumns = [
        {
            dataField: 'client',
            text: 'Client',
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'hmo',
            text: 'HMO',
            headerStyle: {
                textAlign: 'center',
                width: '125px'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'policy',
            text: 'Policy #',
            headerStyle: {
                textAlign: 'center',
                width: '125px'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'incidentNumber',
            text: 'Incident #',
            headerStyle: {
                textAlign: 'center',
                width: '125px'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'patientName',
            text: 'Patient Name',
            headerStyle: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'itnNumber',
            text: 'ITN',
            headerStyle: {
                textAlign: 'center',
                width: '110px'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'providerName',
            text: 'Provider',
            headerStyle: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'datesOfService',
            text: 'Dates of Service',
            headerStyle: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'totalChargeFormatted',
            text: 'Billed Amount',
            headerStyle: {
                textAlign: 'center',
                width: '100px'
            },
            sort: true,
            style: {
                textAlign: 'right'
            },
            filter: textFilter(),
        },
        {
            dataField: 'currency',
            text: 'Billed Currency',
            headerStyle: {
                textAlign: 'center',
                width: '100px'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'hasBills',
            text: 'Details',
            headerStyle: {
                textAlign: 'center',
                width: '50px'
            },
            style: {
                textAlign: 'center'
            },
            formatter: billsFormatter
        }
    ];

    const incidentsColumns = [
        {
            dataField: 'client',
            text: 'Client',
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'policy',
            text: 'Policy #',
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'incidentNumber',
            text: 'Incident #',
            headerStyle: {
                textAlign: 'center',
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'patientName',
            text: 'Patient Name',
            headerStyle: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'hasBills',
            text: 'Details',
            headerStyle: {
                textAlign: 'center',
                width: '50px'
            },
            style: {
                textAlign: 'center'
            },
            formatter: incidentsFormatter
        }
    ];

    const incidentBillsColumns = [
        {
            dataField: 'itnNumber',
            text: 'ITN #',
            headerStyle: {
                textAlign: 'center',
                width: '110px'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'providerName',
            text: 'Provider',
            headerStyle: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'datesOfService',
            text: 'Dates of Service',
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'totalCharge',
            text: 'Billed Amount',
            headerStyle: {
                textAlign: 'center',
                width: '100px'
            },
            style: {
                textAlign: 'right'
            },
            sort: true,
            filter: textFilter(),
            formatter: (cell) => formatCurrency(cell)
        },
        {
            dataField: 'currency',
            text: 'Currency',
            headerStyle: {
                textAlign: 'center',
                width: '100px'
            },
            style: {
                textAlign: 'center'
            },
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'view',
            text: 'View',
            headerStyle: {
                textAlign: 'center',
                width: '50px'
            },
            style: {
                textAlign: 'center'
            },
            formatter: incidentBillsFormatter
        }
    ];

    function billsFormatter(cell, row) {
       
        return (
            <Button className="btn btn-md u-btn-primary" onClick={() => openDetailsDialog(row)}>View</Button>
        );
     
    }

    function incidentsFormatter(cell, row) {

        return (
            <Button className="btn btn-md u-btn-primary" onClick={() => openIncidentsDialog(row)}>View</Button>
        );

    }

    function incidentBillsFormatter(cell, row) {

        return (
            <Button className="btn btn-md u-btn-primary" onClick={() => openIncidentBillPdf(row)}>View</Button>
        );

    }

    const openDetailsDialog = (row) => {
        setRowToEdit(row);
        setShowModal(true);
    }

    const loadIncidentData = (row) => {
        setIsIncidentDataLoading(true);
        let utilization = null;
        let bills = null;

        setPdfUrl("");

        const tryRender = () => {
            if (utilization !== null && bills !== null) {
                setIsIncidentDataLoading(false);
                setIncidentUtilization(utilization);

                // Sort bills by default sort field (itnNumber) in ascending order
                const sortedBills = [...bills].sort((a, b) => {
                    const aVal = a.itnNumber;
                    const bVal = b.itnNumber;

                    if (aVal < bVal) return -1;
                    if (aVal > bVal) return 1;
                    return 0;
                });

                setIncidentBills(sortedBills);
                setIncidentBillsTableData(sortedBills);

                // Automatically load PDF for first bill (after sorting)
                if (sortedBills && sortedBills.length > 0) {
                    openIncidentBillPdf(sortedBills[0]);
                }
            }
        };

        ItnAuthService.getIncidentUtilization(row.incidentNumber, function (u) {
            utilization = u;
            tryRender();
        });

        ItnAuthService.getIncidentBillsList(row.incidentNumber, function (b) {
            bills = b;
            tryRender();
        });
    }

    const openIncidentsDialog = (row) => {
        setIncidentRowToEdit(row);
        loadIncidentData(row);
        setShowIncidentsModal(true);
    }

    const openIncidentBillPdf = (row) => {
        AuthService.getAuthToken(false, (token) => {
            setPdfUrl(`/api/itn/pdf/${row.itnNumber}?token=${token}`);
        });
    }

    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) {
            return "";
        }

        amount = Number(amount);
        if (isNaN(amount)) {
            return "";
        }
        
        return "$" + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total m-1">
            Showing {from} to {to} of {size} entries
        </span>
    );

    const selectRow = {
        mode: 'checkbox',
        hideSelectColumn: true,
    };

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <span className="react-bs-table-sizePerPage-dropdown dropdown">
            <button className="dropdown-toggle btn btn-outline-dark" data-toggle="dropdown" id="dropdownMenuButton" role="group">
                {currSizePerPage + ' per page'}
            </button>
            <ul className="dropdown-menu" role="menu" aria-labelledby="dropdownMenuButton">
                {
                    options.map(option => (
                        <li key={option.text} onClick={() => { onSizePerPageChange(option.page); setNumPerPage(option.page) }}
                            className={'dropdown-item'} role='presentation'>
                            {option.text}
                        </li>
                    ))
                }
            </ul>
        </span>
    );

    const paginationOptions = {
        custom: true,
        showTotal: true,
        totalSize: tableData.length,
        sizePerPageList: [10, 25, 50],
        sizePerPage: numPerPage,
        nextPageText: 'Next',
        prePageText: 'Previous',
        sizePerPageRenderer,
        paginationTotalRenderer: customTotal
    };

    const incidentsPaginationOptions = {
        custom: true,
        showTotal: true,
        totalSize: incidentTableData.length,
        sizePerPageList: [10, 25, 50],
        sizePerPage: numPerPage,
        nextPageText: 'Next',
        prePageText: 'Previous',
        sizePerPageRenderer,
        paginationTotalRenderer: customTotal
    };

    const incidentBillsPaginationOptions = {
        custom: true,
        showTotal: true,
        totalSize: incidentBillsTableData.length,
        sizePerPageList: [10, 25, 50],
        sizePerPage: numPerPage,
        nextPageText: 'Next',
        prePageText: 'Previous',
        sizePerPageRenderer,
        paginationTotalRenderer: customTotal
    };

    const ErrorFallback = ({ error, resetErrorBoundary }) => {
        return (
            <div role="alert">
                There was an error processing the search results. Please search again.
            </div>
        )
    }

    const onFormSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            return;
        }

        executeSearch();
    }

    const executeSearch = () => {
        if (clientCodeList.length === 0) {
            ErrorDisplay.renderError('Client list is not yet initialized and is required for search. Please try again in a moment.');
            return;
        }

        setShowList(false);
        setShowNoResults(false);
        setIsLoading(true);

        var postData = {
            clients: allClients ? clientCodeList : selectedClientList
        };

        getAuthorizationData(postData);
    }

    const getAuthorizationData = (request) => {
        if (cancelToken) {
            cancelToken.cancel("Current activity search reset");
        }

        var instanceToken = axios.CancelToken.source();
        setCancelToken(instanceToken);

        if (approveByClaim) {        
            ItnAuthService.getAuthorizationData(request, instanceToken, function (authData) {
                setData(authData);
                setTableData(authData);

                if (authData.length === 0) {
                    
                    setShowNoResults(true);
                } else {
                    setShowList(true);
                }
            
                setIsLoading(false);
            });
        } else {
            ItnAuthService.getIncidentsData(request, instanceToken, function (incidentsData) {
                setIncidentData(incidentsData);
                setIncidentTableData(incidentsData);

                if (incidentsData.length === 0) {
                    setShowNoResults(true);
                } else {
                    setShowList(true);
                }
            
                setIsLoading(false);
            });
        }

        if (denyList.length === 0) {
            ItnAuthService.getDenyList(function (data) {
                setDenyList(data);
            });
        }

        if (infoList.length === 0) {
            ItnAuthService.getInfoList(function (data) {
                setInfoList(data);
            });
        }
    }

    const resetForm = (e) => {
        e.preventDefault();

        if (cancelToken) {
            cancelToken.cancel("Authorization search reset");
        }

        ErrorDisplay.clear();
        setIsLoading(false);
        setAllClients(true);
        setData([]);
        setTableData([]);
        setShowList(false);
        setShowNoResults(false);
    }

    const handleCancel = (e) => {
        e.preventDefault();

        resetModal(true);
        setShowModal(false);
    }

    const handleSave = (e) => {
        e.preventDefault();

        saveAuthorization(false);

    }

    const handlePrevious = (e) => {
        var next = true;
        var rowToDelete = 0
        var itnToDelete = "";
        for (var i = 0; i < tableData.length; i++) {
            if (tableData[i].itnNumber === rowToEdit.itnNumber) {
                rowToDelete = i;
                
                if (i === tableData.length - 1) {
                    next = false;
                }
                                     
            }
        }


       
        if (rowToDelete > 0 && next) {
            resetModal(true);
            setRowToEdit(tableData[rowToDelete - 1]);
        } else {
            setShowModal(false);
        }
    }

    const handleNext = (e) => {
        e.preventDefault();

        var next = true;
        var rowToDelete = 0
        var itnToDelete = "";
        for (var i = 0; i < tableData.length; i++) {
            if (tableData[i].itnNumber === rowToEdit.itnNumber) {
                rowToDelete = i;
                
                if (i === tableData.length - 1) {
                    next = false;
                }
                                     
            }
        }

       
        if (tableData.length > rowToDelete && next) {
            resetModal(true);
            setRowToEdit(tableData[rowToDelete + 1]);
        } else {
            setShowModal(false);
        }

    }

    const handleSaveAndNext = (e) => {
        e.preventDefault();

        saveAuthorization(true);
    }

    const resetModal = (resetAction) => {
        if (resetAction) {
            setSelectedAction("N");
        }

        setPatientResponsibilityValue(0);
        setMaximumCoveredValue(0);
        setDenialCodeValue("0");
        setAdditionalInfoValue("0");
        setOtherSpecialHandlingValue("");
        setShowClientError(false);
        setClientError("");
        setSaveButtonDisabled(true);
    }
    
    const isAuthorizationValid = () => {
        setShowClientError(false);
        setClientError("");

        var errorMessages = "";

        if (selectedAction === "A") {

            var billedAmount = Number(rowToEdit.totalCharge);

            if (Number(patientResponsibilityValue) > billedAmount) {
                errorMessages += "Patient Responsibility cannot be greater than Total Charge. ";
            }

            if (Number(maximumCoveredValue) > billedAmount) {
                errorMessages += "Maximum Covered Amount cannot be greater than Total Charge. ";
            }

            if (Number(patientResponsibilityValue) < 0) {
                errorMessages += "Patient Responsibility cannot be less than zero. ";
            }

            if (Number(maximumCoveredValue) < 0) {
                errorMessages += "Maximum Covered Amount cannot be less than zero. ";
            }
        }

        if (selectedAction === "D") {
            if (denialCodeValue === "0") {
                errorMessages += "Reason for Denial is Required";
            }
        }

        if (selectedAction === "I") {
            if (additionalInfoValue === "0") {
                errorMessages += "Info Required is Required";
            }
        }

        if (selectedAction === "O") {
            if (otherSpecialHandlingValue.trim().length < 5 || otherSpecialHandlingValue.trim().length > 500) {
                errorMessages += "Special Handling Comment must be between 5 and 500 characters";
            }
        }

        if (errorMessages !== "") {
            setShowClientError(true);
            setClientError(errorMessages);
            return false;
        }

        return true;
    }

    const saveAuthorization = (next) => {

        if (!isAuthorizationValid()) {
            return;
        }

        setIsSaving(true);

        if (cancelToken) {
            cancelToken.cancel("Save Authorization Cancelled");
        }

        var instanceToken = axios.CancelToken.source();
        setCancelToken(instanceToken);

        var request = {
            "itn": rowToEdit.itnNumber,
            "patientResponsibility": (selectedAction === 'A' ? patientResponsibilityValue : undefined),
            "patientResponsibilityCurrency": (selectedAction === 'A' ? rowToEdit.currency : undefined),
            "maximumCovered": (selectedAction === 'A' ? maximumCoveredValue : undefined),
            "maximumCoveredCurrency": (selectedAction === 'A' ? rowToEdit.currency : undefined),
            "denialCode": (selectedAction === 'D' ? denialCodeValue : undefined),
            "additionalInfo": (selectedAction === 'I' ? additionalInfoValue : undefined),
            "otherSpecialHandling": (selectedAction === 'O' ? otherSpecialHandlingValue : undefined),
        };

        AnalyticsService.sendEventWithClient('cc_authorization_create', {
            flow_type: 'itn_authorization',
            action_type: selectedAction,
            has_itn: !!(rowToEdit && rowToEdit.itnNumber)
        });
        
        ItnAuthService.processAuthorization(request, instanceToken, function (resp) {
            
            setIsSaving(false);
            
            if (resp.statusCode !== 200) {
                setShowClientError(true);
                setClientError(resp.message);
            } else {
                var rowToDelete = 0
                var itnToDelete = "";
                for (var i = 0; i < tableData.length; i++) {
                    if (tableData[i].itnNumber === rowToEdit.itnNumber) {
                        rowToDelete = i;
                        
                        if (i === tableData.length - 1) {
                            next = false;
                        }
                                             
                        itnToDelete = tableData[i].itnNumber;
                    }
                }

                if (!next) {
                    setShowModal(false);
                } else {
                    if (tableData.length > rowToDelete && next) {
                        resetModal(true);
                        setRowToEdit(tableData[rowToDelete + 1]);
                    }
                }

                var newTableData = tableData.filter((m, _) => {

                    if (m.itnNumber === itnToDelete) {
                        return null;
                    }
                    
                    return m;
                });

                var newData = data.filter((m, _) => {

                    if (m.itnNumber === itnToDelete) {
                        return null;
                    }
                    
                    return m;
                });

          
                if (newData) {
                    setData(newData);
                } else {
                    setNewData([]);
                }

                if (newTableData) {
                    setTableData(newTableData);
                } else {
                    setTableData([]);
                }
               
            }
        });


    }

    // Incident Modal Functions
    const isIncidentValid = () => {
        setShowClientError(false);
        setClientError("");

        var errorMessages = "";

        if (selectedAction === "N") {
            errorMessages += "Please select either Approve or Deny. ";
        }

        if (selectedAction === "D") {
            if (denialCodeValue === "0") {
                errorMessages += "Reason for Denial is Required";
            }
        }

        if (errorMessages !== "") {
            setShowClientError(true);
            setClientError(errorMessages);
            return false;
        }

        return true;
    }

    const resetIncidentModal = (resetAction) => {
        if (resetAction) {
            setSelectedAction("N");
        }

        setDenialCodeValue("0");
        setShowClientError(false);
        setClientError("");
        setSaveButtonDisabled(true);
    }

    const saveIncident = (next) => {

        if (!isIncidentValid()) {
            return;
        }

        setIsSaving(true);

        if (cancelToken) {
            cancelToken.cancel("Save Incident Cancelled");
        }

        var instanceToken = axios.CancelToken.source();
        setCancelToken(instanceToken);

        var request = {
            "incident": incidentRowToEdit.incidentNumber,
            "maximumCovered": (selectedAction === 'A' ? incidentUtilization.maximumCovered : undefined),
            "maximumCoveredCurrency": (selectedAction === 'A' ? incidentUtilization.maximumCoveredCurrency : undefined),
            "denialCode": (selectedAction === 'D' ? denialCodeValue : undefined),
            "billsList": incidentBills.map(bill => ({ itn: bill.itnNumber }))
        };

        ItnAuthService.processIncident(request, instanceToken, function (resp) {

            setIsSaving(false);

            if (resp.statusCode !== 200) {
                setShowClientError(true);
                setClientError(resp.message);
            } else {
                var rowToDelete = 0
                var incidentToDelete = "";
                for (var i = 0; i < incidentTableData.length; i++) {
                    if (incidentTableData[i].incidentNumber === incidentRowToEdit.incidentNumber) {
                        rowToDelete = i;

                        if (i === incidentTableData.length - 1) {
                            next = false;
                        }

                        incidentToDelete = incidentTableData[i].incidentNumber;
                    }
                }

                if (!next) {
                    setShowIncidentsModal(false);
                } else {
                    if (incidentTableData.length > rowToDelete && next) {
                        resetIncidentModal(true);
                        setIncidentRowToEdit(incidentTableData[rowToDelete + 1]);
                        loadIncidentData(incidentTableData[rowToDelete + 1]);
                    }
                }

                var newTableData = incidentTableData.filter((m, _) => {

                    if (m.incidentNumber === incidentToDelete) {
                        return null;
                    }

                    return m;
                });

                var newData = incidentData.filter((m, _) => {

                    if (m.incidentNumber === incidentToDelete) {
                        return null;
                    }

                    return m;
                });


                if (newData) {
                    setIncidentData(newData);
                } else {
                    setIncidentData([]);
                }

                if (newTableData) {
                    setIncidentTableData(newTableData);
                } else {
                    setIncidentTableData([]);
                }

            }
        });


    }

    const handleIncidentCancel = (e) => {
        e.preventDefault();

        resetIncidentModal(true);
        setShowIncidentsModal(false);
    }

    const handleIncidentPrevious = (e) => {
        var next = true;
        var rowToDelete = 0
        var incidentToDelete = "";
        for (var i = 0; i < incidentTableData.length; i++) {
            if (incidentTableData[i].incidentNumber === incidentRowToEdit.incidentNumber) {
                rowToDelete = i;

                if (i === incidentTableData.length - 1) {
                    next = false;
                }

            }
        }



        if (rowToDelete > 0 && next) {
            resetIncidentModal(true);
            setIncidentRowToEdit(incidentTableData[rowToDelete - 1]);
            loadIncidentData(incidentTableData[rowToDelete - 1]);
        } else {
            setShowIncidentsModal(false);
        }
    }

    const handleIncidentNext = (e) => {
        e.preventDefault();

        var next = true;
        var rowToDelete = 0
        var incidentToDelete = "";
        for (var i = 0; i < incidentTableData.length; i++) {
            if (incidentTableData[i].incidentNumber === incidentRowToEdit.incidentNumber) {
                rowToDelete = i;

                if (i === incidentTableData.length - 1) {
                    next = false;
                }

            }
        }


        if (incidentTableData.length > rowToDelete && next) {
            resetIncidentModal(true);
            setIncidentRowToEdit(incidentTableData[rowToDelete + 1]);
            loadIncidentData(incidentTableData[rowToDelete + 1]);
        } else {
            setShowIncidentsModal(false);
        }

    }

    const handleIncidentSaveAndNext = (e) => {
        e.preventDefault();

        saveIncident(true);
    }

    const onTableChange = (type, newState) => {
        console.log(type);
        console.log(newState);
        
        if (type === "filter") {
            updateDataFilter(newState.filters);
        }

        if (type === "sort") {
            setSortField(newState.sortField);
            setSortDir(newState.sortOrder);
            updateDataSort(newState.sortField, newState.sortOrder);
        }
    }

    const onIncidentsTableChange = (type, newState) => {
        console.log(type);
        console.log(newState);
        
        if (type === "filter") {
            updateIncidentsDataFilter(newState.filters);
        }

        if (type === "sort") {
            setIncidentSortField(newState.sortField);
            setIncidentSortDir(newState.sortOrder);
            updateIncidentsDataSort(newState.sortField, newState.sortOrder);
        }
    }

    const updateIncidentsDataFilter = (filters) => {
        var filteredData = incidentData;
        
        if (filters["client"]) {
            filteredData = filterText(filteredData, filters.client.filterVal, "client");
        }
        
        if (filters["policy"]) {
            filteredData = filterText(filteredData, filters.policy.filterVal, "policy");
        }

        if (filters["incidentNumber"]) {
            filteredData = filterText(filteredData, filters.incidentNumber.filterVal, "incidentNumber");
        }

        if (filters["patientName"]) {
            filteredData = filterText(filteredData, filters.patientName.filterVal, "patientName");
        }

        setIncidentTableData(filteredData);
    }

    const updateIncidentsDataSort = (field, order) => {
        function compareAsc(a, b) {

            var aVal = a[field];
            var bVal = b[field];

            if (field == "totalChargeFormatted") {
                aVal = prepCurrencyStringForSort(aVal);               
                bVal = prepCurrencyStringForSort(bVal);
            } 

            if (aVal < bVal) {
                return -1;
            }
        
            if (aVal > bVal) {
                return 1;
            }
                return 0;
            
            }

        function compareDesc(a, b) {
            var aVal = a[field];
            var bVal = b[field];
            
            if (field == "totalChargeFormatted") {
                aVal = prepCurrencyStringForSort(aVal);               
                bVal = prepCurrencyStringForSort(bVal);
            } 

            if (aVal < bVal) {
                return 1;
            }
        
            if (aVal > bVal) {
                return -1;
            }

            return 0;
        }

        var newData = incidentTableData;
        if (order == "asc") {
            newData.sort(compareAsc);
        } else {
            newData.sort(compareDesc);
        }

        setIncidentTableData(newData);
    }

    const onIncidentBillsTableChange = (type, newState) => {
        console.log(type);
        console.log(newState);

        if (type === "filter") {
            updateIncidentBillsDataFilter(newState.filters);
        }

        if (type === "sort") {
            setIncidentBillsSortField(newState.sortField);
            setIncidentBillsSortDir(newState.sortOrder);
            updateIncidentBillsDataSort(newState.sortField, newState.sortOrder);
        }
    }

    const updateIncidentBillsDataFilter = (filters) => {
        var filteredData = incidentBills;

        if (filters["itnNumber"]) {
            filteredData = filterText(filteredData, filters.itnNumber.filterVal, "itnNumber");
        }

        if (filters["providerName"]) {
            filteredData = filterText(filteredData, filters.providerName.filterVal, "providerName");
        }

        if (filters["datesOfService"]) {
            filteredData = filterText(filteredData, filters.datesOfService.filterVal, "datesOfService");
        }

        if (filters["totalCharge"]) {
            filteredData = filterText(filteredData, filters.totalCharge.filterVal, "totalCharge");
        }

        if (filters["currency"]) {
            filteredData = filterText(filteredData, filters.currency.filterVal, "currency");
        }

        setIncidentBillsTableData(filteredData);
    }

    const updateIncidentBillsDataSort = (field, order) => {
        function compareAsc(a, b) {

            var aVal = a[field];
            var bVal = b[field];

            if (field == "totalCharge") {
                aVal = Number(aVal);
                bVal = Number(bVal);
            }

            if (aVal < bVal) {
                return -1;
            }

            if (aVal > bVal) {
                return 1;
            }
                return 0;

            }

        function compareDesc(a, b) {
            var aVal = a[field];
            var bVal = b[field];

            if (field == "totalCharge") {
                aVal = Number(aVal);
                bVal = Number(bVal);
            }

            if (aVal < bVal) {
                return 1;
            }

            if (aVal > bVal) {
                return -1;
            }

            return 0;
        }

        var newData = [...incidentBillsTableData];
        if (order == "asc") {
            newData.sort(compareAsc);
        } else {
            newData.sort(compareDesc);
        }

        setIncidentBillsTableData(newData);
    }

    const updateDataFilter = (filters) => {
        var filteredData = data;
        
        if (filters["client"]) {
            filteredData = filterText(filteredData, filters.client.filterVal, "client");
        }

        if (filters["policy"]) {
            filteredData = filterText(filteredData, filters.policy.filterVal, "policy");
        }

        if (filters["hmo"]) {
            filteredData = filterText(filteredData, filters.hmo.filterVal, "hmo");
        }

        if (filters["incidentNumber"]) {
            filteredData = filterText(filteredData, filters.incidentNumber.filterVal, "incidentNumber");
        }

        if (filters["patientName"]) {
            filteredData = filterText(filteredData, filters.patientName.filterVal, "patientName");
        }

        if (filters["itnNumber"]) {
            filteredData = filterText(filteredData, filters.itnNumber.filterVal, "itnNumber");
        }

        if (filters["providerName"]) {
            filteredData = filterText(filteredData, filters.providerName.filterVal, "providerName");
        }

        if (filters["datesOfService"]) {
            filteredData = filterText(filteredData, filters.datesOfService.filterVal, "datesOfService");
        }

        if (filters["totalChargeFormatted"]) {
            filteredData = filterText(filteredData, filters.totalChargeFormatted.filterVal, "totalChargeFormatted");
        }

        if (filters["currency"]) {
            filteredData = filterText(filteredData, filters.currency.filterVal, "currency");
        }

        setTableData(filteredData);
    }

    const filterText = (list, filterText, field) => {
        var filteredList = [];
        if (list) {
            for (var i = 0; i < list.length; i++) {
                var fieldVal = list[i][field].toLowerCase();
                var filterVal = filterText.toLowerCase();

                if (fieldVal.indexOf(filterVal) >= 0 || filterText === "") {
                    filteredList.push(list[i]);
                }
            }
        }

        return filteredList;
    }

    const prepCurrencyStringForSort = (input) => {
        var stringVal = input.replaceAll("$", "").replaceAll(",", "");
        return Number(stringVal);
    }


    const updateDataSort = (field, order) => {
        function compareAsc(a, b) {

            var aVal = a[field];
            var bVal = b[field];

            if (field == "totalChargeFormatted") {
                aVal = prepCurrencyStringForSort(aVal);               
                bVal = prepCurrencyStringForSort(bVal);
            } 

            if (aVal < bVal) {
                return -1;
            }
        
            if (aVal > bVal) {
                return 1;
            }
                return 0;
            
            }

        function compareDesc(a, b) {
            var aVal = a[field];
            var bVal = b[field];
            
            if (field == "totalChargeFormatted") {
                aVal = prepCurrencyStringForSort(aVal);               
                bVal = prepCurrencyStringForSort(bVal);
            } 

            if (aVal < bVal) {
                return 1;
            }
        
            if (aVal > bVal) {
                return -1;
            }

            return 0;
        }
        

        let newData = tableData;
        
        if (order == "asc") {
            newData.sort(compareAsc);
        } else {
            newData.sort(compareDesc);
        }

        setTableData(newData);
    }


    return (
        <Layout>
            <ReactNotification />
            <div className="g-ml-25">
                <h1>Authorization Pending</h1>
            </div>
            <div className="row justify-content-center patientSearchForm">
                <div className="col-md-6">
                    <Form onSubmit={onFormSubmit}>
                        {showClientDropdown &&
                            <Form.Group as={Row} controlId="clientDropdown">
                                <Form.Label column md="4" className="required">Client:</Form.Label>
                                <Col md="6">
                                    <Form.Control as="select">
                                        {
                                            clientsForDropdown.map((client, index) => {
                                                return (
                                                    <option key={index} value={client.key}>{client.value}</option>
                                                );
                                            })
                                        }
                                    </Form.Control>
                                </Col>
                            </Form.Group>
                        }
                        {showClientPicker &&
                            <Form.Group as={Row} controlId="allClients">
                                <Form.Label column md="4" className="required">Clients:</Form.Label>
                                <Col md="6">
                                    <Form.Check inline label="All Clients"
                                        checked={allClients} onChange={e => setAllClients(!allClients)} />
                                </Col>
                            </Form.Group>
                        }
                        {(!showClientPicker && !showClientDropdown) &&
                            <Form.Group as={Row} controlId="noClients">
                                <Form.Label column md="4" className="required">Clients:</Form.Label>
                                <Col md="6">
                                    <b>** Clients Loading **</b>
                                </Col>
                            </Form.Group>
                        }
                        {!allClients && showClientPicker &&
                            <Form.Group as={Row} controlId="selectedClients">
                                <Picklist data={clientList} onChange={onSelectedClientsChange} initialSelected={props.searchParams ? props.searchParams.selectedClientList : []} leftLabel="Available Clients:" rightLabel="Selected Clients:" />
                                {showClientError &&
                                    <Col md="12">
                                        <span className="float-right mr-2">Please select at least one client.</span>
                                    </Col>
                                }
                            </Form.Group>
                        }
                        {(showClientPicker || showClientDropdown) &&
                            <>
                                <Form.Group as={Row} controlId="approByType">
                                    <Form.Label column md="4" className="required">Approve By:</Form.Label>
                                    <Col md="6">
                                        <Form.Check type="radio" inline="true" name="approveBy" checked={approveByIncident} onChange={() => { setApproveByIncident(true); setApproveByClaim(false); }} />
                                        <span>Incident</span>
                                        <Form.Check type="radio" inline="true" name="approveBy" checked={approveByClaim} onChange={() => { setApproveByIncident(false); setApproveByClaim(true); }} />
                                        <span>Claim</span>                                   
                                    </Col>
                                </Form.Group>

                                <Button variant="primary" type="submit" className="btn btn-md u-btn-primary">Submit</Button>
                                <Button variant="primary" type="reset" className="gmmi-red" onClick={resetForm}>Reset</Button>
                            </>
                        }
                    </Form>
                </div>
            </div>
            <div className="row justify-content-center">
                {showList && approveByClaim &&
                <div className="row hr-custom">
                        <ErrorBoundary
                                FallbackComponent={ErrorFallback}
                                onError={() => {
                                    executeSearch();
                                }}
                            >
                            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                                {
                                    ({
                                        paginationProps,
                                        paginationTableProps
                                    }) => (
                                        <div className="browser-table">
                                            {searchMsg.length > 0 &&
                                                <h5>{searchMsg}</h5>
                                            }
                                            <div className="row list-view-top">
                                                <div className="col-md-4 list-view-pagination">
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <PaginationTotalStandalone {...paginationProps} />
                                                </div>
                                                <div className="col-md-4">
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            </div>
                                            <BootstrapTable
                                                id="results-list"
                                                bootstrap4
                                                striped
                                                wrapperClasses="table-responsive"
                                                keyField="itnNumber"
                                                data={tableData}
                                                columns={claimsColumns}
                                                {...paginationTableProps}
                                                selectRow={selectRow}
                                                sort={{ dataField: sortField, order: sortDir }}
                                                filterPosition="top"
                                                filtersClasses="filter-wrapper"
                                                onTableChange={onTableChange}
                                                remote={ {
                                                    pagination: false,
                                                    filter: true,
                                                    sort: true,
                                                    cellEdit: false
                                                } }
                                                filter={filterFactory()}
                                            />
                                            <PaginationListStandalone {...paginationProps} />
                                        </div>
                                    )
                                }
                            </PaginationProvider>
                        </ErrorBoundary>
                    </div>
                }

                {showList && approveByIncident &&
                    <div className="row hr-custom"> 
                        <ErrorBoundary
                            FallbackComponent={ErrorFallback}
                            onError={(error, info) => {
                                    executeSearch();
                                }}
                            >
                            <PaginationProvider pagination={paginationFactory(incidentsPaginationOptions)}>
                                {
                                    ({
                                        paginationProps,
                                        paginationTableProps
                                    }) => (
                                        <div className="browser-table">
                                            {searchMsg.length > 0 &&
                                                <h5>{searchMsg}</h5>
                                            }
                                            <div className="row list-view-top">
                                                <div className="col-md-4 list-view-pagination">
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <PaginationTotalStandalone {...paginationProps} />
                                                </div>
                                                <div className="col-md-4">
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            </div>
                                            <BootstrapTable
                                                id="results-list"
                                                bootstrap4
                                                striped
                                                wrapperClasses="table-responsive"
                                                keyField="incidentNumber"
                                                data={incidentTableData}
                                                columns={incidentsColumns}
                                                {...paginationTableProps}
                                                selectRow={selectRow}
                                                sort={{ dataField: incidentSortField, order: incidentSortDir }}
                                                filterPosition="top"
                                                filtersClasses="filter-wrapper"
                                                onTableChange={onIncidentsTableChange}
                                                remote={ {
                                                    pagination: false,
                                                    filter: true,
                                                    sort: true,
                                                    cellEdit: false
                                                } }
                                                filter={filterFactory()}
                                            />
                                            <PaginationListStandalone {...paginationProps} />
                                        </div>
                                    )
                                }
                            </PaginationProvider>
                        </ErrorBoundary>
                    </div>
                }
                

                {isLoading &&
                    <Col md="12" className="justify-content-center providersLoading">
                        <div className="spinner-border"></div>
                    </Col>
                }

                {showNoRusults &&
                    <Col md="12" className="justify-content-center providersLoading">
                        <b>Your search returned no results</b>
                    </Col>
                }
            </div>

            <Modal show={showModal}
                dialogClassName="modal-95w"
                onHide={ () => setShowModal(false) }
                size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        ITN# {rowToEdit?.itnNumber}, Client: {rowToEdit?.client},  Policy# {rowToEdit?.policy}, Patient: {rowToEdit?.patientName}, Billed Amount: {rowToEdit?.totalChargeFormatted}
                        {rowToEdit?.hmo &&
                            <>
                            , HMO: {rowToEdit?.hmo}
                            </>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" name="modelAction" checked={ selectedAction === "A" } onChange={ (e) => setSelectedAction('A')} /> Approve</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Patient Responsiblity</b>
                                    <br />
                                    <span className='itn-subtext'>Total amount to be paid by member</span>
                                </Col>
                                <Col>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>                                        
                                        <Form.Control
                                            type="number"
                                            value={patientResponsibilityValue}
                                            onChange={(e) => setPatientResponsibilityValue(e.target.value)}
                                            disabled={selectedAction !== "A" } /> 
                                        <InputGroup.Append>
                                            <InputGroup.Text>{ rowToEdit?.currency }</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Maximum Covered</b>
                                    <br />
                                    <span className='itn-subtext'>Pay up to for this claim / <br/> Maximum amount covered on this claim</span>
                                </Col>
                                <Col>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>                                        
                                        <Form.Control
                                            type="text"
                                            value={maximumCoveredValue}
                                            onChange={(e) => setMaximumCoveredValue(e.target.value)}
                                            disabled={selectedAction !== "A" } /> 
                                        <InputGroup.Append>
                                            <InputGroup.Text>{ rowToEdit?.currency }</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup> 
                                </Col>
                            </Row>
                            <Row><Col><br /><br /></Col></Row>
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" name="modelAction" checked={ selectedAction === "D" } onChange={(e) => setSelectedAction('D')} /> Deny</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Reason for Denial</b>
                                </Col>
                                <Col>
                                    <Form.Control as="select"
                                        value={denialCodeValue}
                                        onChange={(e) => setDenialCodeValue(e.target.value)}
                                        disabled={selectedAction !== "D"}>
                                        <option value="0">Select a Denial Reason</option>
                                        {
                                            denyList.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.code}>{item.description}</option>
                                                );
                                            })
                                        }
                                    </Form.Control> 
                                </Col>
                            </Row>                            
                            <Row><Col><br /><br /></Col></Row>
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" checked={ selectedAction === "I" } name="modelAction"  onChange={(e) => setSelectedAction('I')} /> Additional Info Needed</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Info Required</b>
                                </Col>
                                <Col>
                                    <Form.Control as="select"
                                        value={additionalInfoValue}
                                        onChange={(e) => setAdditionalInfoValue(e.target.value)}
                                        disabled={selectedAction !== "I"}>
                                        <option value="0">Select Additional Information Required</option>
                                        {
                                            infoList.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.code}>{item.description}</option>
                                                );
                                            })
                                        }
                                    </Form.Control> 
                                </Col>
                            </Row>
                            <Row><Col><br /><br /></Col></Row>
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" name="modelAction" checked={ selectedAction === "O" } onChange={(e) => setSelectedAction('O')} /> Other - Special Handling</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Comment</b>
                                </Col>
                                <Col>
                                    <Form.Control as="textarea"
                                        rows={3}
                                        value={otherSpecialHandlingValue}
                                        onChange={(e) => setOtherSpecialHandlingValue(e.target.value)}
                                        disabled={selectedAction !== "O"} />
                                    { otherSpecialHandlingValue.trim().length } / 500
                                </Col>
                            </Row>
                            <Row><Col>
                                <br /> <br />
                                {showClientError &&
                                    <span className="itn-client-error">Processing Error: { clientError}</span>
                                }

                               
                            </Col></Row>
                            {isSaving &&
                                <Row>
                                    <Col className="justify-content-center">
                                        <div className="spinner-border"></div>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col md className="pdf-col" style={{ height: '600px' }}>
                            <iframe width="100%" height="100%" src={ pdfUrl }></iframe>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving || saveButtonDisabled } onClick={ handleSaveAndNext }>Save</Button>
                    <Button className="gmmi-red" disabled={isSaving} onClick={handleCancel}>Cancel</Button>
                    
                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving } onClick={ handlePrevious }>Previous</Button>
                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving } onClick={ handleNext }>Next</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showIncidentsModal}
                dialogClassName="modal-95w"
                onHide={ () => setShowIncidentsModal(false) }
                size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Client: {incidentRowToEdit?.client},  Policy# {incidentRowToEdit?.policy}, Incident# {incidentRowToEdit?.incidentNumber}, Patient: {incidentRowToEdit?.patientName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            {spinnerEnabled && isIncidentDataLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                    <div className="spinner-border"></div>
                                </div>
                            ) : (
                            <>
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" name="modelAction" checked={ selectedAction === "A" } onChange={ (e) => setSelectedAction('A')} /> Approve</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Maximum Covered on this Incident</b>
                                    <br />
                                    <span className='itn-subtext'>Pay up to for this incident. No patient responsibility.</span>
                                </Col>
                                <Col>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>                                        
                                        <Form.Control
                                            type="text"
                                            value={incidentUtilization?.maximumCovered}
                                            onChange={(e) => setIncidentUtilization({...incidentUtilization, maximumCovered: e.target.value})} /> 
                                        <InputGroup.Append>
                                            <InputGroup.Text>{ incidentUtilization?.maximumCoveredCurrency }</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup> 
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col>
                                    <b>Utilization Summary</b>
                                    <br />
                                    <table className="table table-bordered table-compact">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className="text-center">Provider</th>
                                                { incidentUtilization?.showGMMIFee && <th className="text-center">GMMI Fee</th> }
                                                { incidentUtilization?.showAdminFee && <th className="text-center">Admin Fee</th> }
                                                <th className="text-center">Totals</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Paid</td>
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.paid?.provider) }</td>
                                                { incidentUtilization?.showGMMIFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.paid?.gmmiFee) }</td> }
                                                { incidentUtilization?.showAdminFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.paid?.adminFee) }</td> }
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.paid?.totals) }</td>
                                            </tr>
                                            <tr>
                                                <td>Released</td>
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.released?.provider) }</td>
                                                { incidentUtilization?.showGMMIFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.released?.gmmiFee) }</td> }
                                                { incidentUtilization?.showAdminFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.released?.adminFee) }</td> }
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.released?.totals) }</td>
                                            </tr>
                                            <tr>
                                                <td>Reported</td>
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.reported?.provider) }</td>
                                                { incidentUtilization?.showGMMIFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.reported?.gmmiFee) }</td> }
                                                { incidentUtilization?.showAdminFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.reported?.adminFee) }</td> }
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.reported?.totals) }</td>
                                            </tr>
                                            <tr>
                                                <td>On Hold</td>
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.onHold?.provider) }</td>
                                                { incidentUtilization?.showGMMIFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.onHold?.gmmiFee) }</td> }
                                                { incidentUtilization?.showAdminFee && <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.onHold?.adminFee) }</td> }
                                                <td className="text-right">{ formatCurrency(incidentUtilization?.detail?.onHold?.totals) }</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Remaining Amount</b>
                                </Col>
                                <Col>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>                                        
                                        <Form.Control
                                            type="text"
                                            readOnly
                                            value={((Number(incidentUtilization?.maximumCovered) || 0) - (Number(incidentUtilization?.detail?.reported?.totals) || 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} /> 
                                        <InputGroup.Append>
                                            <InputGroup.Text>{ incidentUtilization?.maximumCoveredCurrency }</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup> 
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col><h4><Form.Check type="radio" inline="true" name="modelAction" checked={ selectedAction === "D" } onChange={(e) => setSelectedAction('D')} /> Deny</h4></Col>
                            </Row>
                            <Row>
                                <Col sm="1"></Col>
                                <Col sm="5">
                                    <b>Reason for Denial</b>
                                </Col>
                                <Col>
                                    <Form.Control as="select"
                                        value={denialCodeValue}
                                        onChange={(e) => setDenialCodeValue(e.target.value)}
                                        disabled={selectedAction !== "D"}>
                                        <option value="0">Select a Denial Reason</option>
                                        {
                                            denyList.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.code}>{item.description}</option>
                                                );
                                            })
                                        }
                                    </Form.Control> 
                                </Col>
                            </Row>      
                            
                            <Row><Col><br /></Col></Row>
                            <Row>
                                <Col>
                                    <PaginationProvider pagination={paginationFactory(incidentBillsPaginationOptions)}>
                                        {
                                            ({
                                                paginationProps,
                                                paginationTableProps
                                            }) => (
                                                <div className="browser-table">
                                                    <div className="row list-view-top">
                                                        <div className="col-md-4 list-view-pagination">
                                                            <SizePerPageDropdownStandalone {...paginationProps} />
                                                            <PaginationTotalStandalone {...paginationProps} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <PaginationListStandalone {...paginationProps} />
                                                        </div>
                                                    </div>
                                                    <BootstrapTable
                                                        id="incident-bills-list"
                                                        bootstrap4
                                                        striped
                                                        wrapperClasses="table-responsive"
                                                        keyField="itnNumber"
                                                        data={incidentBillsTableData}
                                                        columns={incidentBillsColumns}
                                                        {...paginationTableProps}
                                                        selectRow={selectRow}
                                                        sort={{ dataField: incidentBillsSortField, order: incidentBillsSortDir }}
                                                        filterPosition="top"
                                                        filtersClasses="filter-wrapper"
                                                        onTableChange={onIncidentBillsTableChange}
                                                        remote={ {
                                                            pagination: false,
                                                            filter: true,
                                                            sort: true,
                                                            cellEdit: false
                                                        } }
                                                        filter={filterFactory()}
                                                    />
                                                </div>
                                            )
                                        }
                                    </PaginationProvider>
                                </Col>
                            </Row>
                           
                            <Row><Col>
                                {showClientError &&
                                    <span className="itn-client-error">Processing Error: { clientError}</span>
                                }

                               
                            </Col></Row>
                            {isSaving &&
                                <Row>
                                    <Col className="justify-content-center">
                                        <div className="spinner-border"></div>
                                    </Col>
                                </Row>
                            }
                            </>
                            )}
                        </Col>
                        <Col md className="pdf-col" style={{ height: '600px' }}>
                            <iframe width="100%" height="100%" src={ pdfUrl }></iframe>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving || saveButtonDisabled } onClick={ handleIncidentSaveAndNext }>Save</Button>
                    <Button className="gmmi-red" disabled={isSaving} onClick={handleIncidentCancel}>Cancel</Button>

                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving } onClick={ handleIncidentPrevious }>Previous</Button>
                    <Button className="btn btn-md u-btn-primary" disabled={ isSaving } onClick={ handleIncidentNext }>Next</Button>
                </Modal.Footer>
            </Modal>

        </Layout>
    )
};

export default ItnAuthList;